/** SSOT for admin Featured types & helpers — used by AdminFeatured + dashboards. */

export const FEATURED_SLOTS = [
  { value: "homepage",          label: "Page d'accueil",     desc: "Landing publique" },
  { value: "talent_dashboard",  label: "Dashboard Talent",   desc: "Affiché aux talents connectés" },
  { value: "creator_dashboard", label: "Dashboard Créateur", desc: "Affiché aux créateurs connectés" },
  { value: "events_section",    label: "Section Événements", desc: "Page /events" },
];

export const FEATURED_KINDS = [
  { value: "concours", label: "Concours" },
  { value: "creator",  label: "Créateur" },
  { value: "talent",   label: "Talent" },
  { value: "collab",   label: "Collaboration" },
  { value: "event",    label: "Événement" },
];

export const slotLabel = (v) => FEATURED_SLOTS.find((s) => s.value === v)?.label || v;
export const kindLabel = (v) => FEATURED_KINDS.find((k) => k.value === v)?.label || v;
